__turbopack_context__.v({
  "loader": "index-module__j50j_W__loader",
});
